import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useEventListener } from '@beef/react';

import { notificationsAnalytics } from '../../analytics';
import { getTopAlertMessage } from '../../selectors';

export const useAccountStatusAnalytics = () => {
  const accountStatusRef = useRef(null);
  const subtitle = useSelector(getTopAlertMessage);

  useEffect(() => { notificationsAnalytics.pushViewEvent(subtitle); }, []);

  useEventListener('click', (event) => {
    const url = event.target.getAttribute('href');

    if (url) {
      const linkText = event.target.innerText;
      notificationsAnalytics.pushClickEvent({ [linkText]: url });
    }
  }, accountStatusRef);

  return { accountStatusRef };
};
